class BaseModel {
  modelUrl = '';
  attributes = {};
  idAttribute = null;

  constructor(attributes) {
    this.cid = 'c_' + (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase();

    attributes && this.set(attributes);
  }

  set = (attributes) => {
    Object.keys(attributes).forEach((key) => {
      if (key === 'id') {
        this[key] = attributes[key];
      }
      this.attributes[key] = attributes[key];
    });
    if(this.idAttribute && this.idAttribute in this.attributes) {
      this.id = this.attributes[this.idAttribute];
    }
  }

  clear = () => {
    const attrs = {};
    for (const key in this.attributes) {
      attrs[key] = undefined;
    }
    return this.set(attrs);
  }

  unset = (key) => delete this.attributes[key];

  get = (attribute) => this.attributes[attribute];

  has = (key) => Boolean(this.attributes[key]);

  url = () => this.has('id') ? `${this.modelUrl}/${this.get('id')}` : this.modelUrl;

  clear = () => {
    this.attributes = {};
  }

  _getMethod = () => {
    return this.has('id') ? 'PUT' : 'POST';
  }

  /**
   * CRUD METHODS
   */
  save = (modelData, callbacks) => {
    const ajax = new Monet.Ajax();
    modelData.attributes ? this.set(modelData.attributes) : this.set(modelData);
    const model = this;
    ajax.url = this.url();
    ajax.method = this._getMethod();
    ajax.data = modelData;
    ajax.success = (response => {
      model.set(response);
      callbacks.success(model, response);
    });
    ajax.error = (err) => {
      callbacks.error && callbacks.error(model, err);
    }

    ajax.send();
  }

  toJSON = () => {
    return this.attributes;
  }
}

App.Models.BaseModel = BaseModel;